







































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import PendingForm from './pendingForm.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import { throttle, download, hasValue } from '@/utils/util'
import { FIRST_VISIT, RESURVEY, MOTION, REVISIT_FINISH } from '@/utils/const'
import RevisitApi from '@/api/revisit'
import MsgBoardDialog from '@/components/task/MsgBoardDialog.vue'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'returnVisitPendingDetail',
	components: {
		PageLayout,
		PendingForm,
		RecordSection,
		MsgBoardDialog,
	},
})
export default class PendingDetail extends Vue {
	private data: any = {}
	private addLoading = false
	private sucDisabled = false
	private FIRST_VISIT = FIRST_VISIT
	private REVISIT_FINISH = REVISIT_FINISH
	private showMsgBoard: boolean = false

	private get taskInfo() {
		return this.data.taskInfo || {}
	}

	private get taskList() {
		const taskInfo = this.data.taskInfo || {}
		let age: Number | null = null
		if (taskInfo.birthday) {
			age = new Date().getFullYear() - new Date(taskInfo.birthday).getFullYear()
		}
		return [
			{
				label: '初次探视订单号',
				value: taskInfo.orderNo,
			},
			{
				label: '派单公司',
				value: taskInfo.companyName,
			},
			{
				label: '伤者姓名',
				value: taskInfo.injuryName,
			},
			{
				label: '伤者年龄',
				value: hasValue(age) ? `${age}岁` : '',
			},
			{
				label: '诊断名称',
				value: taskInfo.diagnoseName,
			},
			{
				label: '治疗方式',
				value: this.$store.state.setting.treatWaysMap[taskInfo.treatWays],
			},
			{
				label: '实际所在医院',
				value: taskInfo.hospital,
			},
			{
				label: '实际所在科室',
				value: taskInfo.department,
			},
			{
				label: '伤者居住地址',
				value: taskInfo.livingAddress,
			},
			{
				label: '案件负责人姓名',
				value: taskInfo.contact,
			},
			{
				label: '案件负责人电话',
				value: taskInfo.contactPhone,
			},
		]
	}

	private get showForm() {
		return this.data.taskStatus >= '20'
	}

	private back() {
		this.$router.go(-1)
	}

	private setSucDisabled(disabled: boolean) {
		this.sucDisabled = disabled
	}

	private getDetail() {
		return RevisitApi.getPendingDetail(this.$route.params.id).then(
			(res: any) => {
				this.data = res.data
			}
		)
	}

	private deactivated() {}

	private activated() {
		this.data = ''
		this.getDetail()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.data = ''
			this.getDetail()
		})
		next()
	}
}
